import { axios } from '@/lib/axios';
import { API_URL_MAIN } from '@/config';

export type I_GetAuthInfo = {
  login_id: string;
  password: string;
  token: string;
};

export type I_GetAuthInfoResponse = {
  access_token: string,
  refresh_token: string;
  error_code: string;
  error_msg: any;
};

export const getAuthInfo = (data: I_GetAuthInfo): Promise<I_GetAuthInfoResponse> => {
  return axios.post(`${API_URL_MAIN}/auth_token`, data);
};
